<template>
  <v-container
    v-if="data"
    class="align-content-start pa-0"
    fill-height
    fluid
  >
    <v-row>
      <v-col
        v-for="(item, index) in data"
        :key="`bank-run-benchmarking-${index}`"
        cols="12"
        lg="4"
        md="6"
      >
        <bank-run-benchmarking-block :data="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import API from '@/api/Api'
import BankRunBenchmarkingBlock from '@/theme/default/views/banking/risk/liquidity/bank-run-benchmarking/BankRunBenchmarkingBlock.vue'

export default {
  name      : 'BankRunBenchmarking',
  components: {
    BankRunBenchmarkingBlock
  },
  mixins   : [i18nRouteMeta],
  dataStore: {
    bankRunBenchmarking         : 'RiskLiquidity.BankRunBenchmarking.Data',
    currentLiquidityParametersId: 'ActiveLiquidityParameters.currentLiquidityParametersId'
  },
  data () {
    return {
      minBlockHeight: 364
    }
  },
  computed: {
    accountId () {
      return this.user?.selectedAccountId || null
    },
    data () {
      return this.bankRunBenchmarking.Data || {}
    }
  },
  created () {
    this.getBankRunBenchmarking()
    this.$bus.$on('liquidity:cancel-assumptions-edit', this.getBankRunBenchmarking)
  },
  beforeDestroy () {
    this.$bus.$off('liquidity:cancel-assumptions-edit', this.getBankRunBenchmarking)
  },
  methods: {
    async getBankRunBenchmarking () {
      const response = await API.Resource.RiskLiquidity.GetBankRunBenchmarking(this.accountId, this.currentLiquidityParametersId)
      this.handleResponse(response, 'bankRunBenchmarking')
    },

    handleResponse (response, key) {
      const data = API.responseData(response)?.[key] || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        this.$set(this[key], 'Data', data)
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
      </script>

      <style scoped>
      </style>
